import {clsx, styled, Box, IconButton, ArrowBackIosIcon, ArrowForwardIosIcon} from 'external/material'
import { centerVertically } from 'utils/style'
import {dashboardActivityItemWidth, dashboardActivityItemMargin} from 'settings'

const NavigationButton = styled(Box)(buttonNavigationStyles)

const activityWidth = dashboardActivityItemMargin + dashboardActivityItemWidth

export function DashboardActivityPreviousButton(props) {
    const {activityElement, className, scrollLeft, setScrollLeft} = props
    const {scrollWidth = 0, offsetWidth = 0} = activityElement.current || {}
    const visible = scrollWidth > offsetWidth
    const disabled = scrollLeft == 0

    function handleClick() {
      setScrollLeft(Math.max(scrollLeft - activityWidth, 0))
    } 


    return (
      <NavigationButton className={clsx('navigation-button-container', {visible})}>
        <IconButton disableRipple className={className} disabled={disabled} onClick={handleClick}>
          <ArrowBackIosIcon className="icon previous" />
        </IconButton>
      </NavigationButton>
   )
}

export function DashboardActivityNextButton(props) {

    const {activityElement,  className, scrollLeft, setScrollLeft} = props
    const {scrollWidth = 0, offsetWidth = 0} = activityElement.current || {}

    const visible = true
    const maximumScroll = scrollWidth - offsetWidth 
    const disabled = scrollLeft == maximumScroll

    function handleClick() {
      setScrollLeft(Math.min(scrollLeft + activityWidth, maximumScroll))
    } 

    return (
      <NavigationButton className={clsx('navigation-button-container', {visible})}>
        <IconButton disableRipple className={className} disabled={disabled} onClick={handleClick}>
          <ArrowForwardIosIcon className="icon next" />
        </IconButton>
      </NavigationButton>
   )
}

function buttonNavigationStyles (){
    return {
        display: 'none',
        "&.visible": {
          ...centerVertically,
        },
        "& .MuiButtonBase-root": {
          "&:hover": {
           backgroundColor: 'transparent !important' 
          },
          "& .previous": {
          },
          "& .icon": {
            fontSize: '20pt',
            color: '#4f556d',
          },
          "&.Mui-disabled": {
            "& .icon": {
              color: 'lightgray'
            }
          },
        },
    }
}
